"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceLineSnapshotDto = exports.InvoiceLineInputDto = exports.INVOICE_TAX_TREATMENTS = void 0;
const class_validator_1 = require("class-validator");
exports.INVOICE_TAX_TREATMENTS = [
    "standard",
    "exempt",
    "reverse_charge",
    "outside_scope",
];
class InvoiceLineInputDto {
    description;
    quantity;
    unitPrice;
    taxTreatment;
    taxRate;
    taxReason;
    reference;
}
exports.InvoiceLineInputDto = InvoiceLineInputDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], InvoiceLineInputDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false, maxDecimalPlaces: 4 }),
    (0, class_validator_1.Min)(0.0001),
    (0, class_validator_1.Max)(1_000_000),
    __metadata("design:type", Number)
], InvoiceLineInputDto.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false, maxDecimalPlaces: 4 }),
    (0, class_validator_1.Min)(-100_000_000),
    (0, class_validator_1.Max)(100_000_000),
    __metadata("design:type", Number)
], InvoiceLineInputDto.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(exports.INVOICE_TAX_TREATMENTS),
    __metadata("design:type", String)
], InvoiceLineInputDto.prototype, "taxTreatment", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({ allowInfinity: false, allowNaN: false, maxDecimalPlaces: 2 }),
    (0, class_validator_1.IsIn)([0, 4, 10, 21]),
    __metadata("design:type", Number)
], InvoiceLineInputDto.prototype, "taxRate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.ValidateIf)((line) => line.taxTreatment !== "standard"),
    __metadata("design:type", String)
], InvoiceLineInputDto.prototype, "taxReason", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], InvoiceLineInputDto.prototype, "reference", void 0);
class InvoiceLineSnapshotDto extends InvoiceLineInputDto {
    subtotal;
    tax;
    total;
    currency;
}
exports.InvoiceLineSnapshotDto = InvoiceLineSnapshotDto;
